export const ROUTES = {
  LOGIN: '/login',
  UNAUTHORIZED: '/unauthorized',
  ASSISTANT: '/assistant',
  DASHBOARD: '/dashboard',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:id',
  ORDERS: '/orders',
  CATALOG: '/catalog',
  OFFERS: '/offers',
  OFFER_NEW: '/offers/new',
  OFFER_EDIT: '/offers/:id',
  SETTINGS: '/settings',
  SETTINGS_EXCHANGE_RATE: '/settings/exchange-rate',
  SETTINGS_AUDIT: '/settings/audit',
} as const;
